import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CONTENT_COLLECTION_INSTRUCTIONS } from "@air/feature-content-collection/constants";
import { Help as HelpIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Popover } from "@air/primitive-popover";
export const ContentCollectionInstructionPopover = ()=>{
    return /*#__PURE__*/ _jsx(Popover, {
        className: "max-w-[320px]",
        align: "end",
        sideOffset: 24,
        trigger: /*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: "grey",
            icon: HelpIcon,
            label: "Instructions",
            size: "large"
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-2 p-3",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-14 font-medium text-grey-12",
                    children: "How it works"
                }),
                /*#__PURE__*/ _jsx("ul", {
                    children: CONTENT_COLLECTION_INSTRUCTIONS.map((instruction, index)=>/*#__PURE__*/ _jsxs("li", {
                            className: "flex flex-col gap-1 border-b border-b-grey-5 py-3 last:border-b-0 last:pb-0",
                            children: [
                                /*#__PURE__*/ _jsxs("h3", {
                                    className: "flex items-center gap-3 text-14 font-medium text-grey-11",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex size-6 items-center justify-center",
                                            children: instruction.icon
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: instruction.label
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "pl-9 text-12 text-grey-10",
                                    children: instruction.description
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};
